// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toolbar[data-v-2bb3d779] { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 10px; margin-bottom: 16px;\n}.toolbar .el-input[data-v-2bb3d779] { width: 240px;\n}.danger[data-v-2bb3d779] { color: #f56c6c;\n}.hint[data-v-2bb3d779] { margin-left: 8px; color: #909399; font-size: 12px;\n}.el-pagination[data-v-2bb3d779] { margin-top: 16px; text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
